/**
 * Catálogo de clientes del panel — source of truth.
 *
 * Lista estática por ahora; cuando exista el endpoint /api/clients lo
 * hidratamos desde ahí. El slug coincide con el ClientSlug del schema.
 */
import type { ClientSlug, Platform } from "@/types";

export interface ClientCard {
  slug: ClientSlug;
  /** Nombre corto para sidebar/cards. */
  label: string;
  /** Nombre largo para hero del dashboard. */
  fullName: string;
  /** Una línea para describir el tipo de cuenta. */
  tagline: string;
  /** País / mercado principal. */
  market: string;
  /** Plataformas conectadas. */
  platforms: Platform[];
  /** Color de acento del cliente (de la paleta neon). */
  accent: string;
  /** Estado de salud — hardcoded por ahora. */
  health: "ok" | "warn" | "muted";
}

export const CLIENTS: ClientCard[] = [
  {
    slug: "huggies-py",
    label: "Huggies PY",
    fullName: "Huggies Paraguay",
    tagline: "Pañales · Kimberly-Clark",
    market: "Paraguay",
    platforms: ["instagram", "facebook"],
    accent: "#FFFF00",
    health: "ok",
  },
  {
    slug: "huggies-uy",
    label: "Huggies UY",
    fullName: "Huggies Uruguay",
    tagline: "Pañales + Dermacare · Kimberly-Clark",
    market: "Uruguay",
    platforms: ["instagram", "facebook"],
    accent: "#ADFF00",
    health: "ok",
  },
  {
    slug: "plenitud-uy",
    label: "Plenitud UY",
    fullName: "Plenitud Uruguay",
    tagline: "Cuidado personal adulto · Kimberly-Clark",
    market: "Uruguay",
    platforms: ["instagram", "facebook"],
    accent: "#00FFFF",
    health: "ok",
  },
  {
    slug: "qxtel",
    label: "QXTEL",
    fullName: "QXTEL",
    tagline: "Telecomunicaciones B2B global",
    market: "London / Global",
    platforms: ["instagram"],
    accent: "#00FFB2",
    health: "muted",
  },
  {
    slug: "champe-agency",
    label: "Champe interno",
    fullName: "Champe Agency",
    tagline: "Cuenta interna · piloto CM",
    market: "Buenos Aires / Madrid / Miami",
    platforms: ["instagram", "facebook"],
    accent: "#ADFF00",
    health: "ok",
  },
  {
    slug: "tom",
    label: "TOM",
    fullName: "Tortugas Open Mall",
    tagline: "Shopping al aire libre · Tortuguitas",
    market: "Tortuguitas / Argentina",
    platforms: ["instagram", "facebook"],
    accent: "#FF0069",
    health: "ok",
  },
];

export function findClient(slug: string | undefined): ClientCard | undefined {
  if (!slug) return undefined;
  return CLIENTS.find((c) => c.slug === slug);
}

/** Slugs autorizados — para validar params del router. */
export const CLIENT_SLUGS = CLIENTS.map((c) => c.slug);
